module.exports = __webpack_public_path__ + "img/22-23AM_Asian.1528cf2f.jpg";